module.exports = __webpack_public_path__ + "static/media/Union.c01f89da.svg";